import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import bg from "../assets/images/pc.png";
import pd from "../assets/images/pd.png";
import { Modal } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";

const BinanceFutures = () => {
    const [opened, { open , close}] = useDisclosure(false);
  const portfolios = [
    {
      name: "YHW1",
      followers: "233 / 800",
      api: true,
      pnl: "+296,915.08",
      roi: "+25.65%",
      aum: "967,525.89",
      mdd: "41.18%",
      sharpe: "--",
      chart: "📈", // placeholder
    },
    {
      name: "Mia He",
      followers: "356 / 600",
      api: true,
      pnl: "+108,394.06",
      roi: "+23.60%",
      aum: "879,485.79",
      mdd: "11.23%",
      sharpe: "--",
      chart: "📉",
    },
    {
      name: "币圈阿拉丁",
      followers: "37 / 200",
      api: false,
      pnl: "+100,134.96",
      roi: "+4.88%",
      aum: "703,302.68",
      mdd: "10.24%",
      sharpe: "--",
      chart: "📊",
    },
  ];
  return (
    <div>
      <Header />
      <div className="bg-white dark:bg-gray-900 text-gray-900 dark:text-white transition-colors duration-300">
        <div style={{ backgroundImage: `url(${bg})` }}>
          {/* Top Section */}
          <div className="max-w-6xl mx-auto py-16 px-4">
            <h1 className="text-3xl font-bold text-gray-900">
              Trade Crypto Futures
            </h1>
            <p className="mt-2 text-gray-600">
              Sign up, verify identity and get up to{" "}
              <span className="text-red-500 font-semibold">$5,000</span> free
              position
            </p>
            <button onClick={open} className="mt-4 bg-yellow-400 hover:bg-yellow-500 text-black font-semibold px-5 py-2 rounded-md">
              Open Account
            </button>
            <Modal onClose={close} opened={opened} title="Verify Account" centered>
                <div className="flex flex-col items-center py-10">
                    <button className="bg-yellow-400 text-black font-medium px-6 py-2 rounded hover:bg-yellow-500 transition">Verify Now</button>
                </div>
            </Modal>
            <p className="mt-2 text-sm text-gray-400">Last login: 2025-08-18</p>
            

            {/* Crypto Prices */}
            <div className="grid grid-cols-2 sm:grid-cols-5 gap-6 mt-10 text-center">
              {[
                { name: "BTCUSD", change: "-2.22%", price: "115,504.90" },
                { name: "ETHUSD", change: "-4.40%", price: "4,283.96" },
                { name: "SOLUSD", change: "-5.37%", price: "182.34" },
                { name: "BNBUSD", change: "-2.25%", price: "831.88" },
                { name: "XRPUSD", change: "-4.65%", price: "2.9798" },
              ].map((coin, idx) => (
                <div key={idx}>
                  <p className="font-medium text-gray-800">
                    {coin.name}{" "}
                    <span className="text-red-500 font-semibold">
                      {coin.change}
                    </span>
                  </p>
                  <p className="text-gray-500">Perpetual</p>
                  <p className="text-xl font-bold text-gray-900">
                    {coin.price}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
        {/* Promotion Section */}
        <div className="max-w-6xl mx-auto mt-16 grid md:grid-cols-2 gap-10 items-center px-4">
          <div>
            <h2 className="text-2xl font-bold text-gray-900">
              Buy BFUSD with Zero Fees
            </h2>
            <p className="text-sm text-gray-400 mt-2">
              2025-01-14 16:13 |{" "}
              <span className="text-yellow-500 cursor-pointer">
                Share to Friends
              </span>
            </p>
            <p className="mt-3 text-gray-600">
              Enjoy Zero Purchase Fees for BFUSD for another 3 months! T&Cs
              apply.
            </p>
            <button className="mt-4 bg-yellow-400 hover:bg-yellow-500 text-black font-semibold px-5 py-2 rounded-md">
              Learn More
            </button>
          </div>

          {/* Right Promo Card */}
          <div className="bg-black text-white rounded-2xl p-6 flex flex-col justify-between">
            <p className="text-yellow-400 font-bold text-sm">TILLIONX FUTURES</p>
            <h3 className="text-2xl font-bold mt-3 leading-snug">
              ENJOY ZERO PURCHASE FEES FOR BFUSD
            </h3>
            <p className="text-sm text-gray-300 mt-2">PROMOTION EXTENDED</p>
            <button className="mt-5 bg-yellow-400 hover:bg-yellow-500 text-black font-semibold px-5 py-2 rounded-md">
              BUY BFUSD NOW
            </button>
            <p className="text-xs text-gray-500 mt-3">
              DISCLAIMER: You are solely responsible for your investment
              decisions. Tillionx is not liable for any losses.
            </p>
          </div>
        </div>

        <div className="py-16 my-12 px-6">
          <div className="max-w-6xl mx-auto">
            {/* Title */}
            <h2 className="text-3xl font-bold text-gray-900 mb-10">
              Value Proposition
            </h2>

            {/* Value Points */}
            <div className="grid md:grid-cols-2 gap-10">
              {/* Item 1 */}
              <div className="flex items-start gap-4">
                <div className="text-yellow-500 text-2xl">🔰</div>
                <div>
                  <h3 className="font-semibold text-lg text-gray-900">
                    Unparalleled trading products & services
                  </h3>
                  <p className="text-gray-600 text-sm mt-1">
                    Access to over 250+ Futures & Options contracts with a wide
                    range of trading tools, margin modes, and 24/7 global expert
                    customer support.{" "}
                    <span className="text-yellow-500 cursor-pointer">More</span>
                  </p>
                </div>
              </div>

              {/* Item 2 */}
              <div className="flex items-start gap-4">
                <div className="text-yellow-500 text-2xl">💎</div>
                <div>
                  <h3 className="font-semibold text-lg text-gray-900">
                    Ultra competitive pricing
                  </h3>
                  <p className="text-gray-600 text-sm mt-1">
                    Trade crypto Futures with the lowest transaction fees on the
                    market and the tightest bid/ask spread.{" "}
                    <span className="text-yellow-500 cursor-pointer">More</span>
                  </p>
                </div>
              </div>

              {/* Item 3 */}
              <div className="flex items-start gap-4">
                <div className="text-yellow-500 text-2xl">🖥️</div>
                <div>
                  <h3 className="font-semibold text-lg text-gray-900">
                    Trade seamlessly via any platform
                  </h3>
                  <p className="text-gray-600 text-sm mt-1">
                    Trade via our user-focused and reliable range of web, app,
                    desktop and API trading platforms.{" "}
                    <span className="text-yellow-500 cursor-pointer">More</span>
                  </p>
                </div>
              </div>

              {/* Item 4 */}
              <div className="flex items-start gap-4">
                <div className="text-yellow-500 text-2xl">⚡</div>
                <div>
                  <h3 className="font-semibold text-lg text-gray-900">
                    Industry-Leading Execution & Liquidity
                  </h3>
                  <p className="text-gray-600 text-sm mt-1">
                    Tillionx Futures is built with an industry-leading matching
                    engine that can support high transactions per second to
                    enable the best market execution and liquidity.{" "}
                    <span className="text-yellow-500 cursor-pointer">More</span>
                  </p>
                </div>
              </div>
            </div>

            {/* Portfolio Margin Program */}
            <div className="grid md:grid-cols-2 gap-10 items-center mt-20">
              {/* <div className="w-48 h-48 bg-gradient-to-r from-yellow-100 to-white rounded-lg flex items-center justify-center shadow">
              📊
            </div> */}
              <img src={pd} alt="Portfolio Margin Program" />

              <div>
                <h2 className="text-2xl font-bold text-gray-900">
                  Portfolio Margin Program
                </h2>
                <p className="text-gray-600 mt-3 text-sm">
                  Tillionx Portfolio Margin Program broadens margin scope to
                  include balances on the Cross Margin, USDⓈ-M Futures, and
                  COIN-M Futures Wallets as part of one single joint collateral.
                </p>
                <button className="mt-5 bg-yellow-400 hover:bg-yellow-500 text-black font-semibold px-5 py-2 rounded-md">
                  Learn More
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="py-16 px-6">
          <div className="max-w-6xl mx-auto">
            {/* Title + Link */}
            <div className="flex justify-between items-center mb-8">
              <h2 className="text-2xl font-bold text-gray-900">
                Top Lead Portfolios
              </h2>
              <a
                href="#"
                className="text-yellow-500 font-medium hover:underline flex items-center"
              >
                View All Lead Traders →
              </a>
            </div>

            {/* Portfolio Cards */}
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {portfolios.map((p, idx) => (
                <div
                  key={idx}
                  className="border rounded-xl p-5 shadow-sm hover:shadow-md transition"
                >
                  {/* Profile */}
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 bg-gray-300 rounded-full flex items-center justify-center text-gray-700 font-bold">
                      {p.name[0]}
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900">{p.name}</h3>
                      <p className="text-sm text-gray-500 flex items-center gap-2">
                        👥 {p.followers}{" "}
                        {p.api && (
                          <span className="text-xs bg-gray-200 px-2 py-0.5 rounded">
                            API
                          </span>
                        )}
                      </p>
                    </div>
                  </div>

                  {/* Stats */}
                  <p className="text-sm text-gray-500">7D PNL (USDT)</p>
                  <p className="text-2xl font-bold text-green-600">{p.pnl}</p>
                  <p className="text-sm text-green-500">ROI {p.roi}</p>

                  <div className="grid grid-cols-3 mt-4 text-sm text-gray-600">
                    <div>
                      <p className="font-medium">AUM</p>
                      <p>{p.aum}</p>
                    </div>
                    <div>
                      <p className="font-medium">7D MDD</p>
                      <p>{p.mdd}</p>
                    </div>
                    <div>
                      <p className="font-medium">Sharpe Ratio</p>
                      <p>{p.sharpe}</p>
                    </div>
                  </div>

                  {/* Mini Chart */}
                  <div className="mt-4 h-16 flex items-center justify-center text-2xl">
                    {p.chart}
                  </div>

                  {/* Buttons */}
                  <div className="flex gap-3 mt-5">
                    <button className="flex-1 bg-gray-200 text-gray-700 py-2 rounded font-medium">
                      Mock
                    </button>
                    <button className="flex-1 bg-yellow-400 hover:bg-yellow-500 text-black py-2 rounded font-medium">
                      Copy
                    </button>
                  </div>
                </div>
              ))}
            </div>

            {/* CTA */}
            <div className="text-center mt-16">
              <h2 className="text-2xl font-bold text-gray-900">
                Start Trading Crypto Futures
              </h2>
              <div className="mt-6 sm:flex block justify-center gap-4">
                <button className="bg-yellow-400 hover:bg-yellow-500 text-black font-semibold px-6 py-2 rounded-md mt-2 mx-2">
                  Open Futures Account
                </button>
                <button className="bg-gray-200 text-gray-700 font-semibold px-6 py-2 rounded-md mt-2">
                  Trade Now
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default BinanceFutures;
